import { questionBankList, questionDifficultyList} from "constants/questionBank";
import * as api from "../API/index";
import { authorizedUser } from "components/CommonComponents/CommonFunctions";

export const addQuestionBank = async (bodyData) => {
  try {
    const res = await api.add_question_bank(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
};

export const getQuestionBankList = async (dispatch, pageNum, filters) => {
  try {
    const res = await api.get_question_bank_list(pageNum, filters);
    dispatch({ type: questionBankList, payload: res?.data });
  } catch (error) {
    dispatch({
      type: questionBankList,
      payload: error?.response?.data || error,
    });
    authorizedUser(error?.response?.data);
  }
};

export const getQuestionBankById = async (id, pageNum, filters) => {
  try {
    const res = await api.get_question_bank_by_id(id, pageNum, filters);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const getQuestionBankDifficultyList = async (dispatch, pageNum, filters) => {
  try {
    const res = await api.get_question_bank_difficulty_list(pageNum, filters);
    dispatch({ type: questionDifficultyList, payload: res?.data });
  } catch (error) {
    dispatch({
      type: questionDifficultyList,
      payload: error?.response?.data || error,
    });
    authorizedUser(error?.response?.data);
  }
};

export const updateQuestionBank = async (id, bodyData) => {
  try {
    const res = await api.update_question_bank_by_id(id, bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
};